import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  
      public static url: string;
      public static guid: string;

      set(tempUrl:string){
        TokenService.url = tempUrl.split('=')[1];
      }

      setGuid(tempUrl:string){
        TokenService.guid = tempUrl.split('=')[1];
      }
}
